import { type Asset, assetKindPath } from "@pax/api-contract/assets/v1alpha1";

/** Published pages use the permanent slug; an unpublished asset still has only its id. */
export function assetPage(asset: Pick<Asset, "id" | "kind" | "slug">) {
  return asset.slug
    ? {
        to: "/assets/$kind/$slug" as const,
        params: { kind: assetKindPath(asset.kind), slug: asset.slug },
      }
    : { to: "/assets/$assetId" as const, params: { assetId: asset.id } };
}
